import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-default-package-page-template',
  templateUrl: './default-package-page-template.component.html',
  styleUrls: ['./default-package-page-template.component.scss'],
})
export class DefaultPackagePageTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
